import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = 'website',
  siteName = 'Eurodressage'
}) => {
  const defaultTitle = 'Eurodressage';
  const defaultDescription = 'Eurodressage is the largest dressage and breeding news website on the Internet. Live coverage from the biggest dressage events all over the world.';
  const defaultImage = 'https://www.eurodressage.com/backgrounds/eurodressage_001.jpg';
  const baseUrl = 'https://eurodressage.com';

  const seoTitle = title ? `${title} | ${siteName}` : defaultTitle;
  const ogTitle = title || defaultTitle; // Use title without site name for og:title
  const seoDescription = description || defaultDescription;
  const seoImage = image || defaultImage; // Always ensure we have an image
  const seoUrl = url ? `${baseUrl}${url}` : baseUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={ogTitle} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
      
      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Eurodressage" />
      <link rel="canonical" href={seoUrl} />
    </Helmet>
  );
};

export default SEO;
